import api from '../API';
import { ProfileType } from '../types';

export default {
  async findAll(): Promise<ProfileType[]> {
    const response = await api.get('profile-types');
    return response.data;
  },
};
